import * as React from 'react'

import { Box, Text, colors } from '@factorialco/deprecated-design-system'
import { CategoryBarChart } from '@factorialco/f0-react'
import { clamp } from 'lodash'

import type { Form } from 'modules/performance_process/components/score_configuration_weights/ScoreWeightsSidepanel'
import type { WeightValidationStatus } from 'modules/performance_process/components/score_configuration_weights/ScoreWeightsSidepanel'
import {
  orderStrategies,
  strategyColor,
  strategyTranslation,
} from 'modules/performance_process/lib/reviewStrategy'

type Props = {
  status: WeightValidationStatus
  strategyConfigurations: Form['configurationByStrategy']
  totalProgress: number
  total?: number
}

export const StrategiesProgressBar: React.FC<Props> = ({
  status,
  strategyConfigurations,
  totalProgress,
  total = 100,
}) => {
  const orderedStrategies = orderStrategies(Object.keys(strategyConfigurations))

  const data =
    status === 'exceed'
      ? [{ name: 'exceed', value: totalProgress, color: colors.radicalRed1000 }]
      : orderedStrategies
          .map((strategy) => {
            const config = strategyConfigurations[strategy]
            const weight = config?.weight || 0
            if (!config || !config.producesScore || weight === 0) {
              return null
            }

            return {
              name: strategyTranslation(strategy),
              value: weight,
              color: strategyColor(strategy)[1],
            }
          })
          .filter(Boolean)

  return (
    <Box flexDirection="row" gap="s8" flexGrow alignItems="center">
      <Box
        flexDirection="row"
        flexGrow
        role="group"
        background="grey400"
        borderRadius={{ all: 'abs008' }}
        minHeight="s8"
      >
        <Box
          flexDirection="row"
          gap="s4"
          borderRadius={{ all: 'abs008' }}
          style={{ width: `${clamp(totalProgress, 0, 100)}%`, minWidth: '0', maxWidth: '100%' }}
        >
          <CategoryBarChart data={data} legend={false} />
        </Box>
      </Box>

      <Text.Normal size="200" weight="medium">
        {totalProgress}/{total}
      </Text.Normal>
    </Box>
  )
}
